/* unplugin-vue-components disabled */import script from "./serviceArea2.vue?vue&type=script&setup=true&lang=ts"
export * from "./serviceArea2.vue?vue&type=script&setup=true&lang=ts"

import "./serviceArea2.vue?vue&type=style&index=0&id=005e1cad&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-005e1cad"]])

export default __exports__